import React from "react";
import {
  Spinner,
  Container,
  ProgressBar,
  Row,
  Col,
  InputGroup,
  Form,
  Toast,
} from "react-bootstrap";
import { Redirect } from "react-router-dom";
import Player from "./components/Player";
import {
  fetchPlaylist,
  fetchPlaylistTracks,
  fetchPrograms,
  postNowPlaying,
} from "./services/DataService";
import { datetimeToString } from "./services/UtilityService";
import Timer from "react-compound-timer";
import Sound from "react-sound";
import "./style/player.scss";

class DJ extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      currentTrack: 1,
      isPlaying: false,
      isMuted: false,
      notification: false,
    };
  }

  componentDidMount() {
    fetchPlaylist(this.props.playlistID).then((playlist) => {
      fetchPrograms([]).then(
        (programs) => {
          fetchPlaylistTracks(this.props.playlistID).then((tracks) => {
            let totalDuration = 0;
            let checkpoints = [];
            tracks.forEach((track) => {
              checkpoints.push({
                time: track.duration + totalDuration * 1000,
                callback: () => {
                  this.playTrack(track);
                  this.setState({ currentTrack: track.position });
                },
              });
              track.start = totalDuration;
              totalDuration += track.duration;
            });
            checkpoints.push({
              time: totalDuration * 1000,
              callback: () => {
                if (!this.state.isMuted) {
                  let notification = (
                    <Toast
                      style={{
                        position: "absolute",
                        top: 30,
                        right: 30,
                      }}
                      onClose={() => {
                        this.setState({ notification: false });
                      }}
                    >
                      <Toast.Header>
                        <strong className="mr-auto">Playlist Complete</strong>
                      </Toast.Header>
                      <Sound
                        url="alarm.mp3"
                        playStatus={Sound.status.PLAYING}
                        volume={50}
                      />
                    </Toast>
                  );
                  this.setState({ notification: notification });
                }
              },
            });
            let totalDurationMinutes = Math.floor(totalDuration / 60);
            let totalDurationSeconds = totalDuration % 60;
            this.setState({
              loading: false,
              checkpoints: checkpoints,
              playlist: playlist,
              programs: programs ?? [],
              currentProgram: programs[0].id,
              tracks: tracks,
              totalDuration: totalDuration,
              totalDurationMinutes: totalDurationMinutes,
              totalDurationSeconds: totalDurationSeconds,
            });
          });
        },
        ["current=true"]
      );
    });
  }

  playTrack(track) {
    let np = {};
    np.title = track.name;
    np.artist = track.artist;
    np.album = track.album;
    np.label = track.label ?? "";
    np.program_id = parseInt(this.state.currentProgram);
    np.play_time = datetimeToString();
    // disable for debugging
    postNowPlaying(np).then(() => {
      if (!this.state.isMuted) {
        let notification = (
          <Toast
            delay={5000}
            autohide
            style={{
              position: "absolute",
              top: 30,
              right: 30,
            }}
            onClose={() => {
              this.setState({ notification: false });
            }}
          >
            <Toast.Header>
              <strong className="mr-auto">Now Playing</strong>
            </Toast.Header>
            <Toast.Body>{`${track.name}, ${track.artist} (${track.album})`}</Toast.Body>
            <Sound
              url="notification.mp3"
              playStatus={Sound.status.PLAYING}
              volume={50}
            />
          </Toast>
        );
        this.setState({ notification: notification });
      }
    });
  }

  programToString = (program) => {
    let timeToString = (time) => {
      let ampm = "am";
      let time_parts = time.split(":");
      let hour = parseInt(time_parts[0]);
      let minute = parseInt(time_parts[1]);
      if (hour > 12) {
        hour -= 12;
        ampm = "pm";
      }
      if (hour === 0) hour = 12;
      if (minute < 9) minute = `0${minute}`;
      return `${hour}:${minute} ${ampm}`;
    };
    let days = [];
    if (program.sunday) days.push("S");
    if (program.monday) days.push("M");
    if (program.tuesday) days.push("T");
    if (program.wednesday) days.push("W");
    if (program.thursday) days.push("Th");
    if (program.friday) days.push("F");
    if (program.saturday) days.push("Sa");
    let start_time = timeToString(program.start_time);
    let end_time = timeToString(program.end_time);

    return `${program.name} (${days.join("")}, ${start_time} - ${end_time})`;
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    if (this.state.loading) {
      return (
        <Spinner animation="border" role="status" className="kugs-spinner">
          <span className="sr-only">Loading...</span>
        </Spinner>
      );
    }
    return (
      <Container>
        {this.state.notification ? this.state.notification : ""}

        <h1>{this.state.playlist.name}</h1>

        <Timer
          initialTime={0}
          lastUnit="m"
          formatValue={(value) => `${value < 10 ? `0${value}` : value}`}
          startImmediately={false}
          onStart={() => {
            this.setState({ isPlaying: true });
          }}
          onPause={() => {
            this.setState({ isPlaying: false });
          }}
          onReset={() => {
            this.setState({ currentTrack: 1 });
          }}
          checkpoints={this.state.checkpoints}
        >
          {({ start, pause, reset, getTime, setTime }) => {
            let now = parseInt(getTime() / 1000);
            let nowMinutes = Math.floor(now / 60);
            let nowSeconds = now % 60;
            let total = this.state.totalDuration;
            let totalMinutes = Math.floor(total / 60);
            let totalSeconds = total % 60;
            return (
              <React.Fragment>
                <div>
                  {nowMinutes}:{nowSeconds < 10 ? 0 : ""}
                  {nowSeconds} / {totalMinutes}:{totalSeconds < 10 ? 0 : ""}
                  {totalSeconds}
                </div>

                <Row className="spacer"></Row>

                <ProgressBar
                  className="total-full"
                  min={0}
                  max={this.state.totalDuration}
                >
                  {this.state.tracks.map((track, i) => {
                    return (
                      <ProgressBar
                        striped
                        variant={i % 2 ? "warning" : "danger"}
                        className={i % 2 ? "secondary" : "primary"}
                        now={track.duration}
                        max={this.state.totalDuration}
                        key={`Tbar${i}`}
                      />
                    );
                  })}
                </ProgressBar>

                <ProgressBar
                  className="total-progress"
                  min={0}
                  max={this.state.totalDuration}
                >
                  {this.state.tracks.map((track, i) => {
                    let now = parseInt(getTime() / 1000);
                    if (now > track.start + track.duration) {
                      now = track.duration;
                    } else if (now < track.start) {
                      now = 0;
                    } else {
                      now = now - track.start;
                    }
                    return (
                      <ProgressBar
                        min={0}
                        max={this.state.totalDuration}
                        variant={i % 2 ? "warning" : "danger"}
                        className={i % 2 ? "secondary" : "primary"}
                        now={now}
                        key={`Pbar${i}`}
                      />
                    );
                  })}
                </ProgressBar>

                <Row className="spacer"></Row>
                <Row className="spacer"></Row>
                <Row className="spacer"></Row>

                <Row>
                  <InputGroup>
                    <InputGroup.Prepend>
                      <InputGroup.Text id="program-label">
                        Program
                      </InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      as="select"
                      name="program_id"
                      onChange={(e) => {
                        this.setState({ currentProgram: e.target.value });
                      }}
                    >
                      {this.state.programs.map((program) => {
                        return (
                          <option
                            key={`program-${program.id}`}
                            value={program.id}
                          >
                            {this.programToString(program)}
                          </option>
                        );
                      })}
                    </Form.Control>
                  </InputGroup>
                </Row>

                <Row className="spacer"></Row>
                <Row className="spacer"></Row>
                <Row className="spacer"></Row>

                {this.state.tracks.map((track) => {
                  track.durationMinutes = Math.floor(track.duration / 60);
                  track.durationSeconds = track.duration % 60;
                  let now = parseInt(getTime() / 1000) - track.start;
                  if (this.state.currentTrack < track.position) {
                    now = 0;
                  } else if (this.state.currentTrack > track.position) {
                    now = track.duration;
                  }
                  let nowMinutes = Math.floor(now / 60);
                  let nowSeconds = now % 60;
                  return (
                    <div key={`track-${track.id}`}>
                      <Row>
                        <Col>
                          {track.name}, {track.artist} ({track.album})
                        </Col>
                        <Col>
                          <ProgressBar
                            variant="danger"
                            min={0}
                            max={track.duration}
                            now={now}
                          />
                        </Col>
                        <Col>
                          {nowMinutes}:{nowSeconds < 10 ? 0 : ""}
                          {nowSeconds} / {track.durationMinutes}:
                          {track.durationSeconds < 10 ? 0 : ""}
                          {track.durationSeconds}
                        </Col>
                      </Row>
                      <Row className="spacer"></Row>
                    </div>
                  );
                })}

                <Player
                  start={start}
                  pause={pause}
                  reset={() => {
                    this.setState({ currentTrack: 1 });
                    pause();
                    setTime(0);
                    reset();
                  }}
                  back={() => {
                    let current = this.state.currentTrack;
                    if (current > 1) {
                      current--;
                    }
                    setTime(this.state.tracks[current - 1].start * 1000);
                    this.setState({ currentTrack: current });
                  }}
                  forward={() => {
                    let current = this.state.currentTrack;
                    if (current < this.state.tracks.length) {
                      current++;
                    }
                    setTime(this.state.tracks[current - 1].start * 1000);
                    this.setState({ currentTrack: current });
                  }}
                  mute={() => this.setState({ isMuted: !this.state.isMuted })}
                  isPlaying={this.state.isPlaying}
                  isMuted={this.state.isMuted}
                />
              </React.Fragment>
            );
          }}
        </Timer>

        <Row className="player-spacer"></Row>
      </Container>
    );
  }
}

export default DJ;
